import styled, { useTheme } from 'styled-components';
import { PopoverItemButton, Stack, ButtonReset } from '@koob/margaret';
import { Text } from 'ui';
import { FacilityIcon } from 'components';

const FacilityPopoverItemButton = styled(PopoverItemButton)`
  padding: ${({ theme }) => theme.spacing(0.5)}
    ${({ theme }) => theme.spacing()} ${({ theme }) => theme.spacing(0.5)}
    ${({ theme }) => theme.spacing(2)};

  svg {
    margin-right: 0;
  }

  &:hover {
    color: ${({ theme }) => theme.textLight};
  }

  ${({ isDraggable, theme }) =>
    isDraggable &&
    `
      padding: ${theme.spacing(0.5)} ${theme.spacing()} ${theme.spacing(
        0.5,
      )} ${theme.spacing(0.5)}; 
      width: 100%;
    `}
`;

const FacilityPopoverContent = styled(ButtonReset)`
  flex: 1;
  text-align: left;
`;

const Actions = styled(Stack)`
  svg {
    margin-right: 0;
  }
`;

const FacilityPopoverItem = ({ facility, onClick, actions, isDraggable }) => {
  const theme = useTheme();

  return (
    <FacilityPopoverItemButton as="div" isDraggable={isDraggable}>
      <Stack
        size="full"
        alignX="space-between"
        alignY="center"
        gutterSize={0.5}
      >
        <FacilityPopoverContent
          type={Boolean(onClick) ? 'button' : undefined}
          as={!Boolean(onClick) ? 'div' : undefined}
          onClick={onClick}
        >
          <Stack gutterSize={0.5} alignY="center" size="full">
            {isDraggable && (
              <i
                className="fa-regular fa-grip-dots-vertical"
                style={{ color: theme.textLighter }}
              />
            )}
            <FacilityIcon facility={facility} />
            <Text type="body">
              {facility?.displayName || facility?.enDisplayName}
            </Text>
          </Stack>
        </FacilityPopoverContent>
        {Boolean(actions) && <Actions>{actions}</Actions>}
      </Stack>
    </FacilityPopoverItemButton>
  );
};

export default FacilityPopoverItem;
